/**
 * COPIED FILE. DO NOT EDIT BY HAND.
 *
 * Source of truth: torqagent-api, packages/services/src/systemTeammate/systemTeammateIds.generated.ts,
 * regenerated there with `npm run --workspace packages/server generate-system-teammate-ids`.
 * When that file changes, copy the new values here verbatim.
 *
 * Ids of the built-in ("system") Teammates and Skills declared in the API's system manifest.
 *
 * Each id is a uuidv5 of the manifest key inside the fixed TorqSuite namespace
 * 9f3a1c7e-5b42-4d8f-9c61-0a7e2d4b83f5, so it is the same in every environment, forever. That is
 * what lets this app hold a built-in Teammate id as a constant instead of a per-environment VITE_*
 * variable.
 */

/** Built-in Teammates, keyed by their manifest key. */
export const SYSTEM_TEAMMATE_IDS = {
  'improve-prompt': '48e1efb5-3ba4-5932-bab2-3dab8caeb720', // Prompt Improver
  'improve-system-message': 'fbe0b021-b898-5eae-8e12-f081a275bb63', // System Instruction Improver
  'workforce-assistant': 'e70371f7-258a-5ecf-bbeb-d47044164989', // Workforce Assistant
} as const

export type SystemTeammateKey = keyof typeof SYSTEM_TEAMMATE_IDS

/** Built-in Skills, keyed by their manifest key. Loaded by their Teammate; not listed to users. */
export const SYSTEM_SKILL_IDS = {
  'workforce-assistant-orientation': 'c9a81256-c370-5e2c-8d0c-3f7f6e78117d', // TorqSuite Orientation
  'workforce-assistant-teammate-authoring': '40ed5324-8666-523f-9f30-3161c9d97890', // Building a Teammate
  'workforce-assistant-troubleshooting': '53a07c1f-1bfb-51b1-bf42-d3c5d1036dae', // Troubleshooting TorqSuite
} as const

export type SystemSkillKey = keyof typeof SYSTEM_SKILL_IDS
